import styled, { css } from 'styled-components';
import { UnderlineLink } from '../../../../../../../../CommonComponents/commonStyles';

const normalFont = css`
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  letter-spacing: normal;
`;

const boldFont = css`
  ${normalFont};
 /* // font-weight: bold; */
  font-family: ${props =>
    props.theme.fontFamily.helveticaNeueBold} ;
`;

export const ReceiptsWrapper = styled.div`
  position: relative;
  height: ${props => props.height};
  margin-bottom: 10px;
  white-space: nowrap;
  text-align: ${props => props.isData ? 'center' : 'start'};
  overflow-y: ${props => (props.overflow === 'y' ? 'hidden' : 'scroll')};
  overflow-x: ${props => (props.overflow === 'y' ? 'scroll' : 'hidden')};
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    margin-bottom: 0;
    margin-right: 10px;
  }
`;

export const Receipt = styled.div`
  box-shadow: 0 9px 21px 0 rgba(128, 152, 213, 0.08);
  background-color: #f2f2f2;
  padding: 20px 20px 15px 20px;
  width: 244.5px;
  height: 120px;
  display: inline-block;
  margin-right: 20px;
  overflow: hidden;
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    margin-bottom: 10px;
    display: block;
    width: 98%;
    margin-right: 0;
  }
`;

export const ViewAll = styled(Receipt)`
  width: 94.5px;
  background-color: white;
  padding: 0;
  box-shadow: none;
  & a {
    /* font-family: ${props => props.theme.fontFamily.berkeleyStd}; */
    font-family: BerkeleyStd;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    color: #006778;
    font-size: 16px;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.43;
    text-decoration: underline;
    &:hover {
      color: #006778;
    }
    @media only screen and (max-width: 991px){
      justify-content: center;
    } 
  }
`;

export const DataHolder = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const ReceiptDate = styled.div`
  font-size: 16px;
  ${normalFont}
  line-height: 1.5;
  color: #505050;
  margin: 0;
`;

export const ReceiptTag = styled.p`
  visibility: hidden;
  padding: 3px 10px;
  border: 1px solid #006778;
  color: #006778;
  font-size: 10px;
  //font-weight: bold;
  font-family: ${props =>
    props.theme.fontFamily.helveticaNeueBold} ;
  margin: 0;
  line-height: normal;
`;

export const ReceiptNo = styled.p`
  font-size: 16px;
  ${boldFont}
  line-height: 1.5;
  color: #022737;
  margin: 5px 0;
  white-space: nowrap;
  overflow-x: hidden;
  text-overflow: ellipsis;
`;

export const ReceiptActions = styled.div`
  margin-top: 5px;
`;

export const ReceiptAction = styled(UnderlineLink)`
  color: #006778;
  font-size: 16px;
  line-height: 1.5;
  text-decoration: underline;
  margin-left: ${props => (props.lMargin ? '20px' : '0px')};
  font-family: ${props => props.theme.fontFamily.helveticaNeue};
  &:hover {
    text-decoration: underline;
    color: #006778;
  }
  @media only screen and (max-width: 991px) {
    font-size: ${props => props.theme.fontSize.primary};
  }
`;

export const ReceiptFonts = styled.div`
  font-size: ${props => props.theme.fontSize.h4};
  @media only screen and (min-width) and (max-width: 991px) {
    font-size: ${props => props.theme.fontSize.h5}; 
  }
`;

export const NoData = styled(ReceiptFonts)`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 70%;
  margin: auto;
  font-family: ${props =>
    props.theme.fontFamily.berkeleyStd};
  @media only screen and (min-width: 320px) and (max-width: 991px) {
    color: ${props => props.theme.fontColors.textColor};
    font-size: ${props => props.theme.fontSize.h5}; 
  }
`;
